var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "a/icons/16/shield-check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#FFFFFF",
    transform: "translate(2, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0.5 C7.97163482,1.90866842 10.2778572,2.89995769 12.125,2.89995769 C12.2340258,2.89995769 12.3343571,2.93745118 12.4063646,3.00327557 C12.4613906,3.05357663 12.5,3.12176013 12.5,3.19982373 L12.5,8.79888599 C12.5,10.4697168 11.9224152,11.7631462 10.9741454,12.7759736 C9.78885589,14.0419567 8.04541881,14.8759837 6.14955199,15.4800769 C6.05945535,15.5079859 5.96157799,15.5067352 5.87241606,15.476375 C5.8640875,15.4736141 5.86292606,15.4732475 5.86176462,15.4728809 C3.95886148,14.8721882 2.21450195,14.0408513 1.02846498,12.777135 C0.0783148319,11.7647549 -0.5,10.4707596 -0.5,8.79888599 L-0.5,3.19982373 C-0.5,3.12176013 -0.461390609,3.05357663 -0.40636461,3.00327557 C-0.334357127,2.93745118 -0.234025848,2.89995769 -0.125,2.89995769 C1.72208193,2.89995769 4.03750186,1.90030321 5.64276136,0.618381642 C5.74562581,0.538044287 5.87328044,0.5 6,0.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "4 7.875 5.66666667 9.75 9 6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.92dc2c4a6f4b43c5b961f50381edc214.svg";
export { ForwardRef as ReactComponent };